import { ERROR_CODES } from '@/constants/errorCodes'

let showErrorFn = null

export function setErrorHandler(handler) {
  showErrorFn = handler
}

export function handleApiError(code, message) {
  const errorInfo = ERROR_CODES[code] || { desc: message || '未知错误' }

  if (showErrorFn) {
    showErrorFn(errorInfo.desc)
  } else {
    console.error(`[API Error] ${code}: ${errorInfo.desc}`)
  }

  // 特殊错误处理
  if (code === 401) {
    // APIkey 无效，跳转到获取 APIkey 页面
    window.location.href = '/apikey'
  }
}
